import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createMaterialEntry = createAsyncThunk('createMaterialEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertMaterial`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateMaterialEntry = createAsyncThunk('updateMaterialEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateMaterial`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMaterialData = createAsyncThunk('fetchMaterialData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleMaterial = createAsyncThunk('fetchSingleMaterial', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialList&materialId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleMaterial = createAsyncThunk('deleteSingleMaterial', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteMaterial&materialId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const materialSlice = createSlice({
    name: 'MaterialData',
    initialState: {
        isLoading: false,
        material: null,
        deleteMaterial: null,
        singleMaterial: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMaterialData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMaterialData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.material = action.payload;
        });
        builder.addCase(fetchMaterialData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleMaterial.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteMaterial = action.payload;
        });
        builder.addCase(deleteSingleMaterial.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleMaterial.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleMaterial = action.payload;
        });
        builder.addCase(fetchSingleMaterial.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default materialSlice.reducer;
